import { render, staticRenderFns } from "./ApproveReservationForm.vue?vue&type=template&id=1f48e050"
import script from "./ApproveReservationForm.vue?vue&type=script&lang=js"
export * from "./ApproveReservationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports